const generateDeviceId = () => {
  const uuid = localStorage.getItem("deviceId");
  if (!uuid) {
    const newUuid = crypto.randomUUID();
    localStorage.setItem("deviceId", newUuid);
    return newUuid;
  }
  return uuid;
};

const getDeviceType = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (/mobile/i.test(userAgent)) {
    return "Mobile";
  } else if (/tablet/i.test(userAgent)) {
    return "Tablet";
  } else {
    return "Desktop";
  }
};

const getDeviceName = () => {
  // This can be more complex depending on your requirements
  return navigator.platform; // A simple method to get platform name
};

const getOS = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.indexOf("win") !== -1) return "Windows";
  if (userAgent.indexOf("mac") !== -1) return "MacOS";
  if (userAgent.indexOf("linux") !== -1) return "Linux";
  if (/android/i.test(userAgent)) return "Android";
  if (/iphone|ipad|ipod/i.test(userAgent)) return "iOS";
  return "Unknown OS";
};

const getBrowser = () => {
  const userAgent = navigator.userAgent;
  if (userAgent.indexOf("Firefox") > -1) return "Firefox";
  if (userAgent.indexOf("Chrome") > -1) return "Chrome";
  if (userAgent.indexOf("Safari") > -1) return "Safari";
  if (userAgent.indexOf("Opera") > -1) return "Opera";
  if (userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident") > -1)
    return "Internet Explorer";
  return "Unknown Browser";
};

const getBrowserVersion = () => {
  const userAgent = navigator.userAgent;
  console.log("userAgent", userAgent);
  const match = userAgent.match(
    /(?:chrome|firefox|safari|opera|msie)[/\s](\d+)/i
  );

  return match ? match[1] : "Unknown Version";
};

export const getDeviceInfo = () => {
  const deviceInfo = {
    deviceId: generateDeviceId(), // You can use a method to generate a unique Device ID
    deviceType: getDeviceType(),
    deviceName: getDeviceName(),
    deviceOS: getOS(),
    deviceBrowser: getBrowser(),
    deviceVersion: getBrowserVersion(),
  };

  return deviceInfo;
};

export const analytics = {
  userData: {
    userId: "",
    orgId: "",
    userEmail: "",
  },
  traceId: crypto.randomUUID(),
  identity(data: any) {
    this.userData = data;
  },
  trace(traceId: string) {
    this.traceId = traceId as any;
  },
  trackEvent(event: string, data: any) {
    const deviceInfo = getDeviceInfo();
    const hasUserDetails =
      this.userData?.userId ||
      data?.userId ||
      this.userData?.userEmail ||
      data?.userEmail;
    const hasOrgId = this.userData?.orgId || data?.orgId;

    const shouldTrack = hasUserDetails && hasOrgId;

    if (!shouldTrack) {
      console.error("User ID or Org ID is not set");
      return;
    }
    try {
      fetch(`${process.env.REACT_APP_ANALYTICS_BASE_URL}/api/v1/events`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          traceId: this.traceId,
          eventType: event,
          ...deviceInfo,
          ...this.userData,
          ...data,
        }),
      });
    } catch (error) {
      console.error("Error in trackEvent:", error);
    }
  },
  trackError(
    error: Error,
    data: {
      errorMessage?: string;
      stackTrace?: string;
      errorCode?: string;
      errorType?: string;
      errorSource?: string;
      errorSeverity?: string;
      componentStack?: string;
      digest?: string;
    }
  ) {
    const deviceInfo = getDeviceInfo();

    try {
      fetch(`${process.env.REACT_APP_ANALYTICS_BASE_URL}/api/v1/events`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          traceId: this.traceId,
          eventType: "error",
          ...deviceInfo,
          ...this.userData,
          eventProperties: {
            errorMessage: error.message,
            stackTrace: error.stack,
            errorCode: data.errorCode,
            errorType: data.errorType,
            errorSource: data.errorSource,
            errorSeverity: data.errorSeverity,
            digest: data.digest,
            componentStack: data.componentStack,
          },
        }),
      });
    } catch (error) {
      console.error("Error in trackEvent:", error);
    }
  },
  getIdentity() {
    return this.userData;
  },
  getTraceId() {
    return this.traceId;
  },
  getUserData() {
    return this.userData;
  },
  getDeviceInfo() {
    return getDeviceInfo();
  },
};
